import React from "react";
import { Phone, Mail, BarChart, Shield, UserCheck, Search } from "lucide-react";

const ActionCard = ({ icon: Icon, title }) => (
  <div className="flex flex-col items-center justify-center p-6 bg-white shadow-lg rounded-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl">
    <div className="w-16 h-16 bg-blue-50 text-blue-600 flex items-center justify-center rounded-full mb-4 shadow-md">
      <Icon className="w-8 h-8" />
    </div>
    <h3 className="text-center text-gray-800 font-semibold text-lg">{title}</h3>
  </div>
);

const Middle = () => {
  const actions = [
    { icon: UserCheck, title: "Help Find Fugitives & Missing Persons" },
    { icon: Phone, title: "Submit a Tip" },
    { icon: Mail, title: "Contact us 24/7" },
    { icon: BarChart, title: "Find Crime Stats" },
    { icon: Shield, title: "Learn About Common Crimes & Scams" },
    { icon: Search, title: "Discover our History" },
  ];

  return (
    <section className="py-16 bg-[#ccd5ae]">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 text-center mb-10">I Want To</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {actions.map((action, index) => (
            <ActionCard key={index} icon={action.icon} title={action.title} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Middle;
